/**
 * @fileoverview ESM mirror of ../signInReturn.js.
 *
 * See the CJS source for full documentation. Drift between the two is caught by
 * `tests/unit/signInReturn.esmParity.test.js` (behaviour) and `tests/esm/native-import.test.mjs` (names).
 *
 * @module @puffin-core/cross-app-policy/signInReturn
 */

import { safeRelativePathDefect } from './tenantOrigin.js';

const SIGN_IN_RETURN_PARAM = 'returnUrl';

function isSafeReturnPath(value) {
  return safeRelativePathDefect(value) === null;
}

function assertWiredPath(value, subject) {
  const defect = safeRelativePathDefect(value);
  if (defect !== null) {
    throw new Error(`${subject} ${defect}`);
  }
}

function pathOf(path) {
  return path.split(/[?#]/, 1)[0];
}

function signInHref(loginPath, location) {
  assertWiredPath(loginPath, 'signInHref: loginPath');
  const pathname = location && location.pathname;
  if (!isSafeReturnPath(pathname) || pathname === '/' || pathname === pathOf(loginPath)) {
    return loginPath;
  }
  const asked = `${pathname}${location.search || ''}${location.hash || ''}`;
  if (!isSafeReturnPath(asked)) {
    return loginPath;
  }
  const separator = loginPath.includes('?') ? '&' : '?';
  return `${loginPath}${separator}${SIGN_IN_RETURN_PARAM}=${encodeURIComponent(asked)}`;
}

function signInReturnPath(search, options) {
  const { fallback, loginPath } = options || {};
  assertWiredPath(fallback, 'signInReturnPath: fallback');
  const asked = new URLSearchParams(typeof search === 'string' ? search : '').get(
    SIGN_IN_RETURN_PARAM,
  );
  if (!isSafeReturnPath(asked)) {
    return fallback;
  }
  if (loginPath !== undefined && pathOf(asked) === pathOf(loginPath)) {
    return fallback;
  }
  return asked;
}

export { SIGN_IN_RETURN_PARAM, isSafeReturnPath, signInHref, signInReturnPath };
